import TuneIcon from "@mui/icons-material/Tune";

import { RobotoIconButton, RobotoTooltip } from "@/shared/components";
import { usePopupState } from "@/shared/hooks";

import { WorkspaceSettingsDialog } from "./WorkspaceSettingsDialog/WorkspaceSettingsDialog";

/**
 * Header trigger for the workspace settings dialog, placed next to the layout
 * picker — the visualizer's one other preference surface. The dialog mounts
 * only while open, so it reseeds from current session state each time.
 */
export function WorkspaceSettingsButton() {
  const popup = usePopupState();

  return (
    <>
      <RobotoTooltip title="Workspace settings">
        <span>
          <RobotoIconButton
            eventName={"WorkspaceSettingsClicked"}
            onClick={() => popup.open()}
            aria-label="Workspace settings"
          >
            <TuneIcon fontSize="small" />
          </RobotoIconButton>
        </span>
      </RobotoTooltip>
      {popup.isOpen && (
        <WorkspaceSettingsDialog open={popup.isOpen} onClose={popup.close} />
      )}
    </>
  );
}
